import { NumberCoercible } from '../utils/NumberCoercible';
import { NumberFormat } from './NumberFormat';

export type GetCompactNumberPartsReturnType = Intl.NumberFormatPart[];

const NUMBER_FORMAT_OPTIONS = {
  notation: 'compact',
} as const;

export const buildCompactNumberFormat = (locale?: string): Intl.NumberFormat =>
  NumberFormat(locale, NUMBER_FORMAT_OPTIONS);

/**
 * A compact number formatter (short format string representing exponent).
 *
 * @param value The number value to be formatted.
 * @param locale The locale that should be used when formatting the number.
 */
export const compactNumberFormatter = (value: NumberCoercible, locale?: string): string =>
  buildCompactNumberFormat(locale).format(value.valueOf());
